import HTTP from './http'
import { AxiosResponse } from 'axios'
import { getToken } from 'utils/auth'
import { API_HEADER_CONTENT_TYPE as HEADER } from './constants'
import { IHTTPVerbsData } from './interface'

export const taxRegimesGet = ({ entityId, type }: IHTTPVerbsData): Promise<AxiosResponse> =>
  HTTP.panel.get(`/v1/entities/${entityId}/tax-regimes/type/${type}`, {
    headers: {
      ...HEADER.auth.bearer(getToken()),
      ...HEADER.json
    }
  })

export const taxRegimePut = ({ data, entityId }: IHTTPVerbsData): Promise<AxiosResponse> =>
  HTTP.onboarding.put(`/v1/entities/${entityId}/update-tax-regime`, data, {
    headers: {
      ...HEADER.auth.bearer(getToken()),
      ...HEADER.json
    }
  })

export const taxRegimesCatalogsServiceGet = (): Promise<AxiosResponse> =>
  HTTP.panel.get(`/v1/catalogs-service/tax-regimes`, {
    headers: {
      ...HEADER.auth.bearer(getToken()),
      ...HEADER.json
    }
  })
